import React from "react";
import { whyTiles } from "../data/films";
import { stats } from "../data/content";
import { FadeUp } from "./FadeUp";
export function WhyBrandhero() {
  return <section className="py-20 md:py-28" aria-labelledby="why-heading" data-id="element-382" data-mp="14aqlb87894uk">
      <div className="container-x" data-id="element-383" data-mp="qewm5gw99tun">
        <FadeUp data-id="element-384" data-mp="vcextf1nqn6c">
          <h2 id="why-heading" className="font-serif text-[36px] leading-[1.02] tracking-[-0.02em] text-white sm:text-[clamp(40px,4.2vw,56px)]" data-id="element-385" data-mp="vbwszu0xj0mt">
            <span className="sm:block" data-id="element-386" data-mp="1n3kz3yt46qx7">Most AI studios make films.</span>{" "}
            <em className="italic text-signal sm:block" data-id="element-387" data-mp="1n5p12b7gdfuu">We make films that sell.</em>
          </h2>
        </FadeUp>

        <FadeUp className="mt-10 md:mt-12" data-id="element-388" data-mp="1ebaqun1s4vil">
          <ul className="grid gap-4 md:grid-cols-3 md:gap-5" data-id="element-389" data-mp="1ea94vnj86om3">
            {whyTiles.map(tile => <li key={tile.id} className="relative aspect-[4/5] overflow-hidden rounded-[20px] bg-card" data-id="element-390" data-mp="2203e7v4c5v1l">
                <img src={tile.image} alt={tile.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-391" data-mp="26t4vuavxg8ov" />
                <div className="absolute inset-x-0 bottom-0 px-5 pb-5 pt-24" style={{
              background: "linear-gradient(0deg, rgba(0,0,0,0.9), rgba(0,0,0,0))"
            }} data-id="element-392" data-mp="284klgwksvu2k">
                  <p className="font-mono text-[12px] tracking-[0.1em] text-white" data-id="element-393" data-mp="2hw743dzgwvfc">{tile.caption}</p>
                </div>
              </li>)}
          </ul>
        </FadeUp>

        <FadeUp className="mt-12 md:mt-16" data-id="element-394" data-mp="2rqqrixobar2m">
          <dl className="grid grid-cols-2 border-t border-hairline md:grid-cols-4" data-id="element-395" data-mp="2mth1bft3mbdq">
            {stats.map((s, i) => <div key={s.caption} className={`py-8 md:px-8 md:first:pl-0 ${i % 2 === 1 ? "pl-5 border-l border-quiet md:border-l" : ""} ${i > 0 ? "md:border-l md:border-quiet" : ""} ${i > 1 ? "border-t border-quiet md:border-t-0" : ""}`} data-id="element-396" data-mp="30t892yt0uvja" data-mpi={i}>
                <dt className="sr-only" data-id="element-397" data-mp="11hfawyuhzk4z">{s.caption}</dt>
                <dd data-id="element-398" data-mp="31ina8j4bx26q">
                  <span className={`block font-serif text-[44px] leading-none tracking-[-0.02em] md:text-[52px] ${s.accent ? "text-signal" : "text-white"}`} data-id="element-399" data-mp="31j5gm8kpgwsd">
                    {s.value}
                  </span>
                  <span className="mt-3 block font-mono text-[11px] tracking-[0.1em] text-body md:text-[12px]" aria-hidden="true" data-id="element-400" data-mp="3bfi9j48ff6m2">
                    {s.caption}
                  </span>
                </dd>
              </div>)}
          </dl>
        </FadeUp>
      </div>
    </section>;
}